module.exports = __webpack_public_path__ + "static/media/bar-chart.50fb710f.svg";